import axios from "axios"
export function denyApplication(userId, token, fname, email) {
    return axios.get(process.env.REACT_APP_API_URL + `/denyApplication?userId=${userId}&fname=${fname}&email=${email}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}